import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'
import { imageCropDefault } from '../../utilities'
import { MediaAsset } from '../../views'
import { useImageCacheWriter } from '../images'
import {
	landingPageAtom,
	landingPageImageHistoryAtom,
	landingPageImageIdAtom,
	landingPageMetaImageOffsetXAtom,
	landingPageMetaImageOffsetYAtom,
	landingPageMetaImageScaleAtom,
} from '../state'
import { trackLandingPageEdited } from '../tracking'
import { ImageFilmstrip } from './image-filmstrip'

export function LandingPageImageWidget() {
	const assets = useAtomValue(landingPageImageHistoryAtom)
	const { cacheImageUrl } = useImageCacheWriter()

	const landingPageImageId = useAtomValue(landingPageImageIdAtom)

	const setImageScale = useSetAtom(landingPageMetaImageScaleAtom)
	const setImageOffsetX = useSetAtom(landingPageMetaImageOffsetXAtom)
	const setImageOffsetY = useSetAtom(landingPageMetaImageOffsetYAtom)

	const [landingPage, setLandingPage] = useAtom(landingPageAtom)
	const handleImageSelect = useCallback((asset: MediaAsset) => {
		if (landingPage) {
			setLandingPage({ ...landingPage, imageId: asset.id })
		}
		// A crop is a choice about one image's framing; carrying it onto a different
		// one lands somewhere arbitrary, more so when the aspect ratio changes too.
		setImageScale(imageCropDefault.imageScale)
		setImageOffsetX(imageCropDefault.imageOffsetX)
		setImageOffsetY(imageCropDefault.imageOffsetY)
		cacheImageUrl(asset.id, asset.url)
		trackLandingPageEdited('image')
	}, [landingPage, setLandingPage, cacheImageUrl, setImageScale, setImageOffsetX, setImageOffsetY])

	return (
		<ImageFilmstrip
			assets={assets}
			onSelect={handleImageSelect}
			selectedAsset={landingPageImageId ?? ''}
		/>
	)
}
